<template>
  <div class="mb-3 page-break curricular_mesh_print_styles">
    <h4 v-if="cycle">
      {{ $getVisibleNames("mesh.cycle", false, "Ciclo Formativo") }}:
      {{ cycle.name }}
    </h4>
    <div class="legend" v-if="semester == 1">
      {{ $t("studyPlan.studyPlanView.asteriskLegend") }}
    </div>
    <table class="table">
      <thead style="background-color: var(--kl-color-accent-medium)">
        <th :colspan="10 + egress_profile_time_allocations.length">
          {{ numberToWord(semester) }} {{ getLevelLabel().toUpperCase() }}
          <span
            v-can="'mesh.change_egressprofile'"
            v-if="!egressProfile.is_closed"
          >
            <span v-if="limitLevel && limitLevel.max_hours != 0">
              -
              {{
                $getVisibleNames(
                  "manual.total_pedagogical_hours",
                  true,
                  "Total de Horas Pedagógicas"
                )
              }}:
              <span
                :class="
                  limitLevel &&
                  limitLevel.max_hours < totalPedagogicalViewTotalHours
                    ? 'limit-class'
                    : ''
                "
                v-b-tooltip.v-secondary.top.noninteractive="
                  `${$getVisibleNames(
                    'manual.total_pedagogical_hours',
                    true,
                    'Total de Horas Pedagógicas'
                  )}.`
                "
              >
                {{ totalPedagogicalViewTotalHours }}
              </span>
              <span
                v-if="limitLevel && limitLevel.max_hours != 0"
                v-b-tooltip.v-secondary.top.noninteractive="
                  $t('studyPlan.studyPlanView.suggestedMaximum') + '.'
                "
                >/ {{ limitLevel.max_hours }}</span
              >
            </span>
            <span v-if="limitLevel && limitLevel.max_credits != 0">
              - {{ $t("studyPlan.studyPlanView.totalCredits") }}:
              <span
                :class="
                  limitLevel && limitLevel.max_credits < totalSCT
                    ? 'limit-class'
                    : ''
                "
                v-b-tooltip.v-secondary.top.noninteractive="
                  $t('studyPlan.studyPlanView.totalOfCredits') + '.'
                "
              >
                {{ totalSCT }}
              </span>
              <span
                v-if="limitLevel && limitLevel.max_credits != 0"
                v-b-tooltip.v-secondary.top.noninteractive="
                  $t('studyPlan.studyPlanView.suggestedMaximumCredits') + '.'
                "
                >/ {{ limitLevel.max_credits }}</span
              >
            </span>
          </span>
        </th>
        <tr>
          <th scope="col" style="width: 2%">
            {{ $t("studyPlan.studyPlanView.number") }}
          </th>
          <th scope="col" style="width: 10%">
            {{
              $getVisibleNames("mesh.egressprofilematter", true, "Asignaturas")
            }}
          </th>
          <th
            scope="col"
            :title="`${$getVisibleNames(
              'mesh.egressprofilematter',
              true,
              'Asignaturas'
            )} que debe vencer para tomar esta.`"
          >
            {{ $t("studyPlan.studyPlanView.requirements") }}
          </th>
          <th
            scope="col"
            class="header-row-rotated"
            :title="`${$getVisibleNames('mesh.periodtype', true, 'Regímenes')}`"
          >
            {{ $getVisibleNames("mesh.periodtype", true, "Regímenes") }}
            <!-- Períodos -->
          </th>
          <th
            scope="col"
            class="header-row-rotated"
            :title="$t('studyPlan.studyPlanView.weeks')"
          >
            {{ $t("studyPlan.studyPlanView.weeks") }}
          </th>
          <th
            scope="col"
            class="header-row-rotated"
            v-for="hour in time_allocations.filter(
              (x) =>
                x.uses_module_minutes == true &&
                this.egress_profile_time_allocations.includes(x.id)
            )"
            :key="hour.id"
          >
            {{ hour.name }}
          </th>
          <th
            scope="col"
            class="header-row-rotated"
            v-if="showPedagogicalHours"
          >
            {{
              $getVisibleNames(
                "manual.total_pedagogical_hours",
                true,
                "Total de Horas Pedagógicas"
              )
            }}
          </th>
          <th
            scope="col"
            class="header-row-rotated"
            v-if="showPedagogicalHours"
          >
            {{
              $getVisibleNames(
                "manual.total_pedagogical_hours_to_chronological",
                true,
                "Total de Horas Pedagógicas (En Cronológicas)"
              )
            }}
          </th>
          <th
            scope="col"
            v-for="hour in time_allocations.filter(
              (x) =>
                x.uses_module_minutes == false &&
                this.egress_profile_time_allocations.includes(x.id)
            )"
            :key="hour.id"
          >
            {{ hour.name }}
          </th>
          <th
            v-if="
              institution &&
              institution.internal_use_id != 'ipss.cl' &&
              showChronologicalHours
            "
            scope="col"
            class="header-row-rotated"
          >
            {{
              $getVisibleNames(
                "manual.total_chronological_hours",
                true,
                "Total de Horas Cronológicas"
              )
            }}
          </th>
          <th
            v-if="
              institution &&
              institution.internal_use_id != 'ipss.cl' &&
              showPedagogicalHours &&
              showChronologicalHours
            "
            scope="col"
            class="header-row-rotated"
          >
            {{
              $getVisibleNames(
                "manual.total_hours_sum_to_chronological",
                true,
                "Total de Horas (Pedagógicas + Cronológicas)"
              )
            }}
          </th>
          <!-- <th scope="col" class="header-row-rotated" title="Módulos Teóricas">
            Módulos Teóricos
          </th>
          <th
            scope="col"
            class="header-row-rotated"
            title="Módulos Lab/Talleres"
          >
            Módulos Lab / Talleres
          </th>
          <th
            scope="col"
            class="header-row-rotated"
            title="Módulos Terreno/Campo Clínico"
          >
            Módulos Terreno / Campo Clínico
          </th>
          <th scope="col" class="header-row-rotated" title="Módulos Ayudantía">
            Módulos Ayudantía
          </th>
          <th
            scope="col"
            class="header-row-rotated"
            title="Módulos Presenciales Semanales"
          >
            Módulos Presenciales Semanales
          </th>
          <th
            scope="col"
            class="header-row-rotated"
            title="Total de Horas Presenciales Cronológicas"
          >
            Total de Horas Presenciales Cronológicas
          </th>
          <th
            scope="col"
            class="header-row-rotated"
            title="Horas Autónomas Totales"
          >
            Horas Autónomas Semanales
          </th>
          <th
            scope="col"
            class="header-row-rotated"
            :title="
              $getVisibleNames(
                'manual.total_autonomous_hours',
                false,
                'Total de Horas Autónomas'
              )
            "
          >
            {{
              $getVisibleNames(
                "manual.total_autonomous_hours",
                false,
                "Total de Horas Autónomas"
              )
            }}
          </th> -->
          <th
            v-if="institution && institution.internal_use_id != 'ipss.cl'"
            scope="col"
            class="header-row-rotated"
            :title="
              $getVisibleNames('manual.credits', true, 'Créditos SCT Totales')
            "
          >
            {{
              $getVisibleNames("manual.credits", true, "Créditos SCT Totales")
            }}
          </th>
        </tr>
      </thead>
      <StudyPlanFormationArea
        v-for="area in formationAreasList"
        :key="area.id"
        :egress_profile_id="egress_profile_id"
        :semester="semester"
        :limit_study_plan="limit_study_plan"
        :egress_profile_time_allocations="egress_profile_time_allocations"
        :formation_area_id="area.id"
        :view_total_hours="view_total_hours"
        :allows_crud="
          allows_crud &&
          ([
            'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
            'DIRECTIVOS ACADÉMICOS (CAMPUS)',
            'DIRECTIVOS FACULTAD O ESCUELA',
          ].some((group) => user.group_names.includes(group)) ||
            user.is_superuser ||
            $hasObjectPermission(
              'mesh.egressprofile',
              'change',
              egressProfile.id
            ))
        "
      ></StudyPlanFormationArea>
      <tr>
        <td colspan="5" style="text-align: end">
          {{ $t("studyPlan.studyPlanView.total") }}
        </td>
        <td
          v-for="hour in time_allocations.filter(
            (x) =>
              x.uses_module_minutes == true &&
              this.egress_profile_time_allocations.includes(x.id)
          )"
          :key="hour.id"
        >
          {{ countTimeAllocationHours(hour.id) }}
        </td>
        <td v-if="showPedagogicalHours">
          {{ totalPedagogical }}
        </td>
        <td v-if="profileType && showPedagogicalHours">
          {{ totalPedagogicalToChronological }}
        </td>
        <td
          v-for="hour in time_allocations.filter(
            (x) =>
              x.uses_module_minutes == false &&
              this.egress_profile_time_allocations.includes(x.id)
          )"
          :key="hour.id"
        >
          {{ countTimeAllocationHours(hour.id) }}
        </td>
        <td
          v-if="
            institution &&
            institution.internal_use_id != 'ipss.cl' &&
            showChronologicalHours
          "
        >
          {{ totalChronological }}
        </td>
        <td
          v-if="
            institution &&
            institution.internal_use_id != 'ipss.cl' &&
            showPedagogicalHours &&
            showChronologicalHours
          "
        >
          {{ totalHours }}
        </td>
        <!-- <td>{{ totalWeekTheoricHours | Round }}</td>
        <td>{{ totalWeekLabHours | Round }}</td>
        <td>{{ totalWeekGroundHours | Round }}</td>
        <td>{{ totalWeekAssistantshipHours | Round }}</td>
        <td>
          <span
            :class="
              limitLevel &&
              limitLevel.max_hours != 0 &&
              limitLevel.max_hours < totalWeekClassroomHours
                ? 'limit-class'
                : ''
            "
            >{{ totalWeekClassroomHours | Round }}</span
          >
        </td>
        <td>{{ Math.round(semesterClassroomHours) }}</td>
        <td>{{ totalWeekAutonomousHours | Round }}</td>
        <td>{{ Math.round(totalSemesterAutonomousHours) }}</td> -->
        <td v-if="institution && institution.internal_use_id != 'ipss.cl'">
          <div v-if="profileType">
            <span
              :class="
                limitLevel &&
                limitLevel.max_credits != 0 &&
                limitLevel.max_credits < totalSCT
                  ? 'limit-class'
                  : ''
              "
              >{{ totalSCT }}</span
            >
          </div>
        </td>
        <!-- <td>{{ semesterCredits }}</td> -->
      </tr>
    </table>
    <div v-if="!(institution && institution.internal_use_id == 'duoc.cl')">
      <div
        v-if="
          !(
            allows_crud &&
            ([
              'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
              'DIRECTIVOS ACADÉMICOS (CAMPUS)',
              'DIRECTIVOS FACULTAD O ESCUELA',
            ].some((group) => user.group_names.includes(group)) ||
              user.is_superuser ||
              $hasObjectPermission(
                'mesh.egressprofile',
                'change',
                egressProfile.id
              ))
          )
        "
      >
        <p v-for="(p, index) in comment.comments.split('\n')" :key="index">
          {{ p }}
        </p>
      </div>
      <div v-else>
        <h6 class="comments-header">
          {{ $t("studyPlan.studyPlanView.commentsOf") }} {{ getLevelLabel() }}
          {{ semester }}
        </h6>
        <ResizeAuto>
          <template v-slot:default="{ resize }">
            <textarea
              :placeholder="
                $t('studyPlan.studyPlanView.enterCommentPlaceholder')
              "
              @input="resize"
              @focus="resize"
              v-model="comment.comments"
              @blur="saveComment"
            ></textarea>
          </template>
        </ResizeAuto>
      </div>
    </div>
  </div>
</template>
<script>
import * as names from "@/store/names";
import StudyPlanFormationArea from "@/components/mesh/StudyPlan/StudyPlanFormationArea";
import { mapGetters } from "vuex";
import ResizeAuto from "@/components/reusable/ResizeAuto";

export default {
  name: "BiannualLevel",
  components: {
    StudyPlanFormationArea: StudyPlanFormationArea,
    ResizeAuto,
  },
  props: {
    egress_profile_id: {
      type: Number,
      required: true,
    },
    semester: {
      type: Number,
      required: true,
    },
    limit_study_plan: {
      type: Object,
      default: null,
    },
    egress_profile_time_allocations: {
      type: Array,
      default: () => [],
    },
    view_total_hours: {
      type: Boolean,
      default: true,
    },
    allows_crud: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      comment: {
        id: -1,
        semester: this.semester,
        comments: "",
        egress_profile: this.egress_profile_id,
      },
    };
  },
  methods: {
    getLevelLabel() {
      if (!this.egressProfile)
        return this.$t("studyPlan.studyPlanView.level").toLowerCase();
      const regime = this.regimes.find(
        (x) => x.id == this.egressProfile.regime
      );
      if (!regime)
        return this.$t("studyPlan.studyPlanView.level").toLowerCase();

      if (regime && regime.alt_name != "") return regime.alt_name;

      if (regime.months_amount == 6) {
        return this.$t("studyPlan.studyPlanView.semester").toLowerCase();
      } else if (regime.months_amount == 3) {
        return this.$t("studyPlan.studyPlanView.quarter").toLowerCase();
      } else if (regime.months_amount == 2) {
        return this.$t("studyPlan.studyPlanView.bimonthly").toLowerCase();
      }
      return this.$t("studyPlan.studyPlanView.level").toLowerCase();
    },
    numberToWord(number) {
      return this.numbersToWord[number - 1]
        ? this.numbersToWord[number - 1]
        : number;
    },
    saveComment() {
      if (!this.comment) return;
      this.comment.egress_profile = this.egressProfile.id;
      if (this.comment.comments.trim().length == 0 && this.comment.id != -1) {
        this.$store.dispatch(names.DELETE_STUDY_PLAN_COMMENT, this.comment.id);
        return;
      }
      if (this.comment.comments.trim().length == 0) return;
      if (this.comment.id == -1) {
        this.$store.dispatch(names.POST_STUDY_PLAN_COMMENT, this.comment);
      } else {
        let payload = {
          study_plan_comment_id: this.comment.id,
          item: {
            comments: this.comment.comments,
          },
        };
        this.$store.dispatch(names.PATCH_STUDY_PLAN_COMMENT, payload);
      }
    },
    countTimeAllocationHours(
      time_allocation_id,
      force_view_total_hours = false
    ) {
      let hours = 0;
      this.mattersBySemester.forEach((matter) => {
        let matter_hour = null;
        let hour = 0;
        if (matter.use_matter_values) {
          matter_hour = this.matter_time_allocations.find(
            (x) =>
              x.matter == matter.matter &&
              x.time_allocation == time_allocation_id
          );
          if (matter_hour && matter_hour.counts_towards_credits) {
            if (this.isAnual && matter.regime == this.isAnual.id)
              hour = parseFloat(matter_hour.hours) / 2;
            else hour = parseFloat(matter_hour.hours);
          }
          // old_matter las semanas de base_matter que se agregan en matterList
          if (
            !this.view_total_hours &&
            matter.old_matter &&
            matter.old_matter.weeks > 0 &&
            !force_view_total_hours
          )
            hour = hour / matter.old_matter.weeks;
          hours += hour;
        } else {
          matter_hour = this.ep_matter_time_allocations.find(
            (x) =>
              x.egress_profile_matter == matter.id &&
              x.time_allocation == time_allocation_id
          );
          if (matter_hour && matter_hour.counts_towards_credits) {
            if (this.isAnual && matter.regime == this.isAnual.id)
              hour = parseFloat(matter_hour.hours) / 2;
            else hour = parseFloat(matter_hour.hours);
          }
          if (
            !this.view_total_hours &&
            matter.weeks > 0 &&
            !force_view_total_hours
          )
            hour = hour / matter.weeks;
          hours += hour;
        }
      });
      return parseFloat(hours.toFixed(2));
    },
    // printingOrientationLandscape() {
    //   var css = "@media print {@page { size: A4 landscape; }}",
    //     head = document.head || document.getElementsByTagName("head")[0],
    //     style = document.createElement("style");
    //   style.type = "text/css";
    //   style.media = "print";

    //   if (style.styleSheet) {
    //     style.styleSheet.cssText = css;
    //   } else {
    //     style.appendChild(document.createTextNode(css));
    //   }
    //   head.appendChild(style);
    // },
    // printingOrientationPortrait() {
    //   var css = "@media print {@page { size: A4 portrait !important; }}",
    //     head = document.head || document.getElementsByTagName("head")[0],
    //     style = document.createElement("style");
    //   style.type = "text/css";
    //   style.media = "print";

    //   if (style.styleSheet) {
    //     style.styleSheet.cssText = css;
    //   } else {
    //     style.appendChild(document.createTextNode(css));
    //   }
    //   head.appendChild(style);
    // },
  },
  computed: {
    ...mapGetters({
      egressProfiles: names.EGRESS_PROFILES,
      matters: names.MATTERS,
      egress_profiles_matters: names.EGRESS_PROFILES_MATTERS,
      numbersToWord: names.NUMBERS_TO_WORDS,
      regimes: names.REGIMES,
      profile_cycles: names.PROFILE_CYCLES,
      profile_types: names.PROFILE_TYPES,
      comments: names.STUDY_PLAN_COMMENTS,
      cycles: names.CYCLES,
      formationAreas: names.FORMATION_AREAS,
      user: "getUser",
      institution: "getInstitution",
      time_allocations: names.TIME_ALLOCATIONS,
      ep_matter_time_allocations: names.EP_MATTER_TIME_ALLOCATIONS,
      courses_wrapper: names.COURSES_WRAPPER,
      matter_time_allocations: names.MATTER_TIME_ALLOCATIONS,
    }),
    isAnual() {
      const months_amount_egress_profile = this.regimes.find(
        (x) => x.id == this.egressProfile.regime
      );
      if (months_amount_egress_profile) {
        if (months_amount_egress_profile.months_amount == 6)
          return this.regimes.find(
            (x) =>
              x.name.includes("Anual") || parseInt(x.months_amount) / 6 == 2
          );
        else if (months_amount_egress_profile.months_amount == 3)
          return this.regimes.find(
            (x) =>
              x.name.includes("Semestral") || parseInt(x.months_amount) / 3 == 2
          );
        else if (months_amount_egress_profile.months_amount == 2)
          return this.regimes.find(
            (x) =>
              x.name.includes("Trimestral") || parseInt(x.months_amount) == 3
          );
      }
      return this.regimes.find(
        (x) => x.name.includes("Anual") || parseInt(x.months_amount) / 6 == 2
      );
    },
    showPedagogicalHours() {
      return (
        this.time_allocations.filter(
          (x) =>
            x.uses_module_minutes == true &&
            this.egress_profile_time_allocations.includes(x.id)
        ).length > 0
      );
    },
    showChronologicalHours() {
      return (
        this.time_allocations.filter(
          (x) =>
            x.uses_module_minutes == false &&
            this.egress_profile_time_allocations.includes(x.id)
        ).length > 0
      );
    },
    formationAreasList() {
      let list = [...this.formationAreas];
      if (list.length > 0)
        list.push({
          id: 0,
          name: this.$t("reusable.common.notApplicable"),
          description: this.$t("studyPlan.studyPlanView.notApply"),
          order: 0,
        });
      else
        list.push({
          id: 0,
          name: "",
          description: "",
          order: 0,
        });
      return list;
    },
    egressProfile() {
      return this.egressProfiles.find((x) => x.id == this.egress_profile_id);
    },
    profileType() {
      if (!this.egressProfile) return [];
      return this.profile_types.find(
        (x) => x.id == this.egressProfile.egress_profile_type
      );
    },
    limitLevel() {
      if (this.limit_study_plan == null) return null;
      else {
        const index = this.limit_study_plan.levels.findIndex(
          (x) => x.level == this.semester
        );
        if (index != -1) return this.limit_study_plan.levels[index];
        else return null;
      }
    },
    coursesWrapperList() {
      return this.courses_wrapper.filter(
        (x) => x.egress_profile == this.egress_profile_id
      );
    },
    wrapperMatterIds() {
      let list = [];
      this.coursesWrapperList.forEach((x) => {
        list = list.concat(x.egress_profile_matters);
      });
      return [...new Set(list)];
    },
    matterList() {
      return this.egress_profiles_matters
        .filter(
          (x) =>
            x.egress_profile == this.egress_profile_id &&
            !this.wrapperMatterIds.includes(x.id)
        )
        .map((x) => {
          const matter = this.matters.find((m) => m.id == x.matter);
          return {
            ...x,
            old_matter: matter ? matter : null,
          };
        });
    },
    getComment() {
      return this.comments.find(
        (x) =>
          x.egress_profile == this.egress_profile_id &&
          x.semester == this.semester
      );
    },
    cycles_avaibles() {
      // Ordena el arreglo basado en el init_semester
      const profile_cycle = [
        ...this.profile_cycles.filter(
          (x) => x.egress_profile == this.egress_profile_id
        ),
      ].sort((a, b) => a.init_semester - b.init_semester);
      const result = profile_cycle.reduce((acc, curr) => {
        // Si el arreglo está vacío, simplemente agrega el primer elemento
        if (acc.length === 0) {
          acc.push(curr);
          return acc;
        }
        // Si el init_semester del elemento actual es mayor al end_semester del último elemento agregado al arreglo,
        // significa que no hay superposición, y por lo tanto, puedes agregar el elemento actual.
        if (curr.init_semester > acc[acc.length - 1].end_semester) {
          acc.push(curr);
        }
        return acc;
      }, []);
      return result.map((x) => x.id);
    },
    cycle() {
      let cycle = null;
      if (this.institution && this.institution.internal_use_id == "umb.edu.co")
        cycle = this.profile_cycles.find(
          (x) =>
            x.init_semester == this.semester &&
            x.egress_profile == this.egress_profile_id &&
            this.cycles_avaibles.includes(x.id)
        );
      else
        cycle = this.profile_cycles.find(
          (x) =>
            x.init_semester == this.semester &&
            x.egress_profile == this.egress_profile_id
        );
      if (cycle) {
        return this.cycles.find((x) => x.id == cycle.cycle);
      }
      return null;
    },
    mattersBySemester() {
      return this.matterList.filter(
        (x) =>
          x.plan_level == this.semester ||
          (this.isAnual &&
            x.regime == this.isAnual.id &&
            x.plan_level == this.semester - 1)
      );
    },
    totalPedagogical() {
      let hours = 0;
      const pedagogical_hours = this.time_allocations.filter(
        (x) => x.uses_module_minutes == true
      );
      pedagogical_hours.forEach((time_allocation) => {
        hours += this.countTimeAllocationHours(time_allocation.id);
      });
      return parseFloat(hours.toFixed(2));
    },
    totalPedagogicalToChronological() {
      if (!this.profileType) return 0;
      if (
        this.institution &&
        parseInt(this.institution.hour_decimal_places) === 0
      ) {
        return parseFloat(
          Math.round(
            this.totalPedagogical *
              (parseFloat(this.profileType.module_minutes) / 60)
          )
        );
      }
      return parseFloat(
        (
          this.totalPedagogical *
          (parseFloat(this.profileType.module_minutes) / 60)
        ).toFixed(
          this.institution && parseInt(this.institution.hour_decimal_places) > 0
            ? parseInt(this.institution.hour_decimal_places)
            : 2
        )
      );
    },
    // Lo mismo de arriba solo que se cuentan solo las horas totales.
    totalPedagogicalViewTotalHours() {
      return parseFloat(
        this.time_allocations
          .filter((x) => x.uses_module_minutes == true)
          .reduce(
            (acc, obj) =>
              acc + parseFloat(this.countTimeAllocationHours(obj.id, true)),
            0
          )
          .toFixed(
            this.institution &&
              parseInt(this.institution.hour_decimal_places) > 0
              ? parseInt(this.institution.hour_decimal_places)
              : 2
          )
      );
    },
    totalChronological() {
      let hours = 0;
      const chronological_hours = this.time_allocations.filter(
        (x) => x.uses_module_minutes == false
      );
      chronological_hours.forEach((time_allocation) => {
        hours += this.countTimeAllocationHours(time_allocation.id);
      });
      return parseFloat(
        hours.toFixed(
          this.institution && parseInt(this.institution.hour_decimal_places) > 0
            ? parseInt(this.institution.hour_decimal_places)
            : 2
        )
      );
    },
    totalHours() {
      if (!this.profileType) return 0;
      const total_hours =
        this.totalPedagogical * (this.profileType.module_minutes / 60) +
        this.totalChronological;
      if (
        this.institution &&
        parseInt(this.institution.hour_decimal_places) === 0 &&
        total_hours
      ) {
        return parseFloat(Math.round(total_hours));
      } else
        return total_hours
          ? parseFloat(
              total_hours.toFixed(
                this.institution &&
                  parseInt(this.institution.hour_decimal_places) > 0
                  ? parseInt(this.institution.hour_decimal_places)
                  : 2
              )
            )
          : 0;
    },
    totalSCT() {
      let totalSCT = 0;
      this.mattersBySemester.forEach((matter) => {
        if (matter.use_matter_values) {
          const old_matter = this.matters.find((x) => x.id == matter.matter);
          if (old_matter) {
            if (this.isAnual && matter.regime == this.isAnual.id)
              totalSCT += old_matter.credits / 2;
            else totalSCT += old_matter.credits;
          }
        } else {
          if (this.isAnual && matter.regime == this.isAnual.id)
            totalSCT += matter.credits / 2;
          else totalSCT += matter.credits;
        }
      });
      return Math.round(totalSCT);
    },
  },
  watch: {
    getComment() {
      if (this.getComment) this.comment = this.getComment;
    },
  },
  mounted() {
    // this.printingOrientationLandscape();
  },
  beforeDestroy() {
    // this.printingOrientationPortrait();
  },
};
</script>

<style scoped>
.table {
  position: relative;
  font-size: 10px;
  border: 1px solid var(--kl-border-black);
  border-width: thin;
}
.legend {
  text-align: right;
}
.table thead th {
  font-size: var(--secondary-font-size) !important;
  padding: 0.2rem;
  vertical-align: middle;
  color: white !important;
  border: 1px solid var(--kl-border-black);
  border-width: thin;
}
th {
  height: 0px;
  background-color: var(--kl-color-accent-medium) !important;
}
.table tr td {
  font-size: var(--secondary-font-size);
  font-weight: bold;
  padding: 2px 2px;
  border: 1px solid var(--kl-border-black);
  border-width: thin;
}
.header-row-rotated {
  /* transform: rotate(270deg);
  text-align: left; */
  padding: 0px;
  margin: 0px;
}
p {
  text-align: left;
  font-family: "Helvetica Neue";
  line-height: 1em;
  font-weight: bold;
  font-style: italic;
  margin: auto;
  padding: 0 1em;
  overflow: hidden;
  display: block;
}
.comments-header {
  text-align: center;
  margin-bottom: -0.5px;
  font-weight: bold;
  font-style: italic;
}
textarea {
  width: 100%;
  margin-top: 5px;
  padding: 4px 8px;
  font-family: "Helvetica Neue";
  line-height: 1em;
  font-weight: bold;
  font-style: italic;
  border: 1px solid var(--kl-input-border);
  border-radius: var(--kl-input-radius);
}
.limit-class {
  color: red;
}
.page-break {
  page-break-before: auto;
  page-break-after: auto;
  page-break-inside: avoid;
}
@media print {
  .curricular_mesh_print_styles_0 {
    width: 100% !important;
    padding-top: 0 !important;
    margin-top: 0 !important;
    display: table;
    table-layout: inherit;
    margin: 0 !important;
  }
}
</style>